//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"CarGeometry",0,"ScCollector",0],[0,"CreateIntersectionGeometry",1,0],[0,"DistanceTolerance",1,0],[1,"FrontHeadRestGeometry",0,"ScCollector",0],[0,"ObstructedColor",1,0],[1,"RearHeadRestGeometry",0,"ScCollector",0],[0,"SeatReferencePoint",1,"Point",0],[0,"Translucency",1,0],[0,"Type",1,0],[0,"UseFrontHeadRests",1,0],[0,"UseRearHeadRests",1,0],[0,"UseWireFrameOnly",1,0],[0,"VisibleColor",1,0],[1,"VisionAreaRadius",0,"Expression",0],[1,"WindowCurveGeometry",0,"Section",0],[1,"WindowFaceGeometry",0,"ScCollector",0],[0,"WindowType",1,0]],[[[],"CreatePointWithBaseDataSGRPExpression",{R_:{tsgrp:"Point"}},0,0]],[]];
SPLM.Features.VehicleDesign.AllAroundVisionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.AllAroundVisionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.AllAroundVisionBuilder.Types = Object.freeze({
    "Pillars" : "Pillars", "Windows" : "Windows"});

SPLM.Features.VehicleDesign.AllAroundVisionBuilder.WindowTypes = Object.freeze({
    "Face" : "Face", "Curve" : "Curve"});

export default SPLM;